import { render, staticRenderFns } from "./client-unit-departaments.vue?vue&type=template&id=3eef17fe&scoped=true&lang=pug&"
import script from "./client-unit-departaments.vue?vue&type=script&lang=ts&"
export * from "./client-unit-departaments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eef17fe",
  null
  
)

export default component.exports